export { default } from './Icon';

export { default as CheckIcon } from './icons/check';
